import React, { useContext, useEffect, useState } from 'react';
import './Navbar.css';
import { createUseStyles } from 'react-jss';
import { AuthContext } from '../../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { types } from '../../types/types';
import { useSelector,useDispatch,getState } from 'react-redux'; 


const styles = createUseStyles( theme => ({
  colorPrimary : {
      color: theme.colorPrimary
  }
}) );

export const Navbar = ({initData,state,setState, typeView}) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal;
  const { 
    nombre,
  } = stateHome;

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })


  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }
  
  useEffect(() => {
    window.addEventListener('resize', detectSize)
    return () => window.removeEventListener('resize', detectSize)
  }, [windowDimenion])

  let movilStyle = {display:'flex', justifyContent:"space-between"}

  const {usuario,dispatch} = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
    dispatch({
      type: types.logout,
    });
  };

  return (
    <nav className="ws-top-navbar">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <div className="logo-container" style={ windowDimenion.winWidth < windowDimenion.winHeight ? movilStyle : {}}>
            <img className="ws-logo" style={{}} src="img/logo_interbrokers.png" alt="logo-app" />

            <div className="logo-banner-name">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    { typeView === 'home' && usuario.tipo_usuario === '1' && 'Atención a clientes' }
                    { typeView === 'home' && usuario.tipo_usuario === '5' && 'Administrador' }
                    { typeView === 'homeCaja' && 'Ejecutivo de caja' }
                    { typeView === 'homeFinanzas' && 'Ejecutivo de finanzas' }
                    { typeView === 'homeProcesos' && 'Ejecutivo de procesos' } | {usuario.nombre}
                  </a>
                  <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                    {/*<a className="dropdown-item" href="#"><i className="bi bi-tools pe-2"></i> Configuración</a>*/}
                    <a className="dropdown-item" href="#"
                    onClick={handleLogout}
                    ><i className="bi bi-power pe-2"></i> Salir</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
